// Definición y evaluación de misiones del Museo Virtual.
// Cada misión se calcula en el cliente a partir de lo que el visitante
// ya descubrió, sin necesitar un motor de misiones en el servidor.

const toDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const MISSION_DEFS = [
  {
    id: 'first_discovery',
    title: 'Primeros pasos',
    description: 'Descubrí tu primera escultura.',
    icon: 'bi-flag-fill',
    xpBonus: 20,
    evaluate: ({ items }) => {
      const discovered = items.filter((i) => i.isDiscovered).length;
      return { completed: discovered >= 1, progress: Math.min(discovered, 1), total: 1 };
    }
  },
  {
    id: 'collector_5',
    title: 'Coleccionista',
    description: 'Descubrí 5 esculturas.',
    icon: 'bi-collection-fill',
    xpBonus: 40,
    evaluate: ({ items }) => {
      const discovered = items.filter((i) => i.isDiscovered).length;
      const total = Math.min(items.length, 5);
      return { completed: total > 0 && discovered >= total, progress: Math.min(discovered, total), total: total || 5 };
    }
  },
  {
    id: 'artist_fan',
    title: 'Fan de un artista',
    description: 'Descubrí todas las obras de un mismo artista.',
    icon: 'bi-person-hearts',
    xpBonus: 40,
    evaluate: ({ items }) => {
      const byArtist = new Map();
      items.forEach((i) => {
        const key = (i.artist || '').trim();
        if (!key) return;
        if (!byArtist.has(key)) byArtist.set(key, { total: 0, discovered: 0 });
        const e = byArtist.get(key);
        e.total += 1;
        if (i.isDiscovered) e.discovered += 1;
      });
      let best = { discovered: 0, total: 1 };
      let anyComplete = false;
      byArtist.forEach((v) => {
        if (v.total <= 1) return;
        if (v.discovered === v.total) anyComplete = true;
        if (v.discovered / v.total > best.discovered / best.total) best = v;
      });
      return { completed: anyComplete, progress: best.discovered, total: best.total };
    }
  },
  {
    id: 'route_complete',
    title: 'Ruta completa',
    description: 'Completá el recorrido de una ruta con varias obras.',
    icon: 'bi-signpost-split-fill',
    xpBonus: 60,
    evaluate: ({ items }) => {
      const byScene = new Map();
      items.forEach((i) => {
        if (!byScene.has(i.sceneId)) byScene.set(i.sceneId, { total: 0, discovered: 0 });
        const e = byScene.get(i.sceneId);
        e.total += 1;
        if (i.isDiscovered) e.discovered += 1;
      });
      let best = { discovered: 0, total: 1 };
      let anyComplete = false;
      byScene.forEach((v) => {
        if (v.total <= 1) return;
        if (v.discovered === v.total) anyComplete = true;
        if (v.discovered / v.total > best.discovered / best.total) best = v;
      });
      return { completed: anyComplete, progress: best.discovered, total: best.total };
    }
  },
  {
    id: 'night_owl',
    title: 'Explorador nocturno',
    description: 'Descubrí una obra entre las 20:00 y las 6:00.',
    icon: 'bi-moon-stars-fill',
    xpBonus: 30,
    evaluate: ({ discoveries }) => {
      const nightOne = discoveries.some((d) => {
        const date = toDate(d.discoveredAt);
        if (!date) return false;
        const h = date.getHours();
        return h >= 20 || h < 6;
      });
      return { completed: nightOne, progress: nightOne ? 1 : 0, total: 1 };
    }
  },
  {
    id: 'complete_museum',
    title: 'Museo completo',
    description: 'Descubrí todas las obras disponibles.',
    icon: 'bi-trophy-fill',
    xpBonus: 100,
    evaluate: ({ items }) => {
      const discovered = items.filter((i) => i.isDiscovered).length;
      const total = items.length;
      return { completed: total > 0 && discovered === total, progress: discovered, total };
    }
  }
];

export function computeMissions({ items, discoveries }) {
  return MISSION_DEFS.map((def) => {
    const result = def.evaluate({ items, discoveries });
    return {
      id: def.id,
      title: def.title,
      description: def.description,
      icon: def.icon,
      xpBonus: def.xpBonus,
      ...result
    };
  });
}
